<p>demokratiewerkstatt-category-create works!</p>
